import { fetchUtils } from '../utils/fetchUtils';

export const getMatchingJobs = (body) => fetchUtils.post('/api/shortlist/job', body);
export const getMatchingResumes = (body) => fetchUtils.post('/api/shortlist/resume', body);
export const getMatchScore = (body) => fetchUtils.post('/api/match', body);
